import { legacyPlugins } from "/baserow-saas/baserow/web-frontend/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}